export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.users': 'User Management',
  'menu.users.users': 'Users',
  'menu.users.roles': 'Roles',
  'menu.users.PartnerCredentials': 'Partner Credentials',
  'menu.Organization': 'Merchant Management',
  'menu.Organization.Branches': 'Branches',
  'menu.Organization.Merchants': 'Merchants',
  'menu.Organization.Products': 'Products',
  'menu.ProductLibrary': 'Product Library',
  'menu.ProductLibrary.Catalog': 'Product Catalog',
  'menu.ProductLibrary.EInvoices': 'E-Invoices',
  'menu.Organization.Terminals': 'Terminals',
  'menu.Organization.Banks': 'Banks',
  'menu.Organization.Transactions': 'Transactions',
  'menu.Organization.EInvoices': 'E-Invoices',
  'menu.Organization.Batches': 'Batches',
  'menu.Report': 'Reports',
  'menu.Report.RevenueSharing': 'Revenue sharing',
  'menu.Loyalty': 'Loyalty',
  'menu.Loyalty.Customers': 'Customers',
  'menu.Loyalty.Rewards': 'Rewards',
  'menu.Loyalty.History': 'History',
  'menu.Loyalty.Policy': 'Policy',
  'menu.Loyalty.Cards': 'Cards',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
